import React from 'react'
import {useTranslation} from 'i18n'
import {ConfirmationModal} from 'common/components'
import {GiftShopTemplateSearchCreationResetModalProps} from './GiftShopTemplateSearchCreationModalResetProps'

export default function GiftShopTemplateSearchCreationResetModal({
  visible,
  onConfirm,
  toggleModal,
}: GiftShopTemplateSearchCreationResetModalProps) {
  const {translate} = useTranslation()

  return (
    <ConfirmationModal
      visible={visible}
      title={translate('giftShop:searchCreationByFileResetTitle')}
      text={translate('giftShop:searchCreationByFileResetDescription')}
      onConfirm={onConfirm}
      toggleModal={toggleModal}
      confirmText={translate('global:yesImSure')}
      cancelText={translate('global:cancel')}
    />
  )
}
